import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductoModel } from 'src/app/shared/models/producto/producto.model';
import { AuthService } from '../../services/auth/auth.service';
import { CarritoService } from '../../services/carrito/carrito.service';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-products-carousel',
  templateUrl: './products-carousel.component.html',
  styleUrls: ['./products-carousel.component.scss']
})
export class ProductsCarouselComponent implements OnInit {

  @Input() productos: ProductoModel[];
  @Input() titulo: string;
  @Output() ProductView = new EventEmitter();

  @Input() mostrarPrecioFinalRjt;
  @Input() mostrarPrecioRjtSinIva;

	responsiveOptions;

  public config = this.configService.config;
  public invitado: boolean = false;
  public mostrarPrecio = this.configService.config.productos.ver_precios == 0 || !this.authService.usuario.invitado;

  public control_stock = this.configService.config.productos.control_stock;
  public tituloSinStock = this.configService.config.productos.titulo_sin_stock;
  public tituloStockMinimo = this.configService.config.productos.titulo_stock_minimo;
  public tituloStockDisponible = this.configService.config.productos.titulo_stock_disponible;
  public mostrarEtiquetaMinimo = this.configService.config.productos.mostrar_etiqueta_minimo;

  //MV CAT-104 Variable para almacenar rol del usuario
  public rol = this.authService.usuario.id_rol_usr_web;

	constructor(
    private configService: ConfigService,
    private authService: AuthService,
    private carritoService: CarritoService,
    public toastr: ToastrService,) {
      this.responsiveOptions = [
        {
            breakpoint: '992px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1
        }
    ];
	}

  ngOnInit(): void {
    this.invitado = this.authService.usuario.invitado;
  }

  addCart(product) {
    if(this.carritoService.validarStock(1, product.stock)){
    let item = {
      id_cliente: this.authService.usuario.id_cliente,
      id_producto: product.id_articulo,
      nombre: product.nombre,
      codigo: product.codigo,
      imagen: product.imagen1,
      precio: product.precio_final,
      precio_neto: product.precio_neto,
      precio_lista: product.precio_lista,
      cantidad: 1,
      stock:product.stock
    };
    // CATWEB-299 Se llama a la funcion changeCart del servicio de carrito para actualizarlo.
    const result = this.carritoService.changeCart(item, true);
    if (result) {
      this.toastr.success(`${product.nombre} `+ CarritoService.MSG_ADD_CART, '', {
        timeOut: 2000,
      });
    }else{
      this.toastr.error(CarritoService.MSG_ERROR_CART);
    }
    }else{
      this.toastr.error(CarritoService.MSG_ERROR_STOCK);
    }
  }

  modalView(event){
    this.ProductView.emit(event);
  }

}
